import Router from 'next/router'

let preparation

export default function prepareProductRoute() {
  if (typeof window === 'undefined') return undefined
  if (!preparation) {
    // Only shared page code: prices, stock and tracking still load normally.
    preparation = Promise.resolve()
      .then(() => Router.prefetch('/product'))
      .catch(() => {
        preparation = undefined
      })
  }
  return preparation
}
